import React from 'react';
import { NOTIFICATION_TYPE } from 'constant';
import useAccounts from 'context/useAccounts';
import useNotifications from 'context/useNotification';

import Account from 'components/account/Account';
import MarketingBanner from 'components/marketingBanner/MarketingBanner';
import AccountMergeModal from 'components/modals/AccountMergeModal';
import OverlaySpinner from 'components/spinner/OverlaySpinner';

const AccountsPage = () => {
    const { hasAmountsPastDue, isFetchingAccounts } = useAccounts();
    const { accountMergeNotifications, acknowledgeNotifications, isFromRegistration } = useNotifications();

    const modalType = isFromRegistration ? 'registration' : 'backgroundMerge';

    return (
        <div className="home-page grey-banner">
            {isFetchingAccounts ? (
                <OverlaySpinner />
            ) : (
                <React.Fragment>
                    <Account />
                    {!hasAmountsPastDue && <MarketingBanner />}
                    <AccountMergeModal
                        accounts={accountMergeNotifications.map((n) => n.message)}
                        modalType={modalType}
                        onOk={() => acknowledgeNotifications(NOTIFICATION_TYPE['MERGED_ACCOUNT'])}
                        visible={!!accountMergeNotifications.length}
                    />
                </React.Fragment>
            )}
        </div>
    );
};

export default AccountsPage;
